import './find.css';
import caduceus from '../images/caduceus.png';
import qrcode from '../images/app-qrcode.jpg';

import React, { Component } from 'react';
import { Link, hashHistory } from 'react-router';
import Icon from '../components/Icon';

import lang from '../services/lang';
import { conditions } from '../services/content';
import { beep } from '../services/audio';
import { trackView } from '../services/analytics';

export default class Find extends Component {
  
  constructor() {
    super();
    this.state = {
      keyword: "",
      studyPhase: "",
      ageGroup: "all",
    };

    trackView("Find Trials");
  }
  
  componentWillMount() {
    beep();
  }
  
  handleSubmit = e => {
    e.preventDefault();
    
    const query = this.state;
    const params = [];
    for(let key in query) {
      if(!!query[key]) {
        params.push(`${key}=${query[key]}`);
      }
    }

    hashHistory.push({
      pathname: '/trials',
      search: '?' + params.join('&')
    });
  }
  
  renderSubcondition = condition => {
    return (
      <Link to={`/trials/${condition.id}`} key={condition.id} className="find-subcondition">
        – {condition.description.trim()}
      </Link>
    );
  }
  
  renderCondition = condition => {
    const subconditions = condition.subConditions || [];
    return (
      <div key={condition.id}>
        <Link to={`/trials/${condition.id}`}>
          <div className="find-condition">{condition.description.trim()}</div>
        </Link>
        {subconditions.map(this.renderSubcondition)}
      </div>
    );
  }
  
  renderContent() {
    
    const { keyword, studyPhase, ageGroup } = this.state;
    
    const phases = {
      'Phase_0': 'Early Phase 1',
      'Phase_1': 'Phase 1',
      'Phase_1_Phase_2': 'Phase 1 / Phase 2',
      'Phase_2': 'Phase 2',
      'Phase_2_Phase_3': 'Phase 2 / Phase 3',
      'Phase_3': 'Phase 3',
      'Phase_4': 'Phase 4',
    };
    
    return (
      <div>
        
        <h1 className="find-title">Find Trials</h1>
        {/*<h3 className="find-subtitle">Need help searching for a trial? <Link to="/contact">Contact our office.</Link></h3>*/}
        {/*<h3 className="find-subtitle">Receive email alerts when trials open to patients! <Link to="/subscription">Sign up here.</Link></h3>*/}

        <form className="find-form" onSubmit={this.handleSubmit}>
          <input 
            type="text"
            className="find-form-input"
            value={keyword}
            onChange={e => this.setState({keyword:e.target.value})}
            placeholder={lang('search-placeholder')}
          />
          
          <div className="find-form-filters-wrapper">
            
            <div className="find-form-filter">
              <div className="find-form-switch-title">Age Group</div>
              <div className="find-form-switch">
                <div 
                  className={`find-form-switch-button ${ageGroup === 'pediatrics' ? 'is-active' : ''}`} 
                  onClick={() => this.setState({ageGroup:'pediatrics'})}>
                  Child
                </div>
                <div 
                  className={`find-form-switch-button ${ageGroup === 'adult' ? 'is-active' : ''}`} 
                  onClick={() => this.setState({ageGroup:'adult'})}>
                 Adult
                </div>
                <div 
                  className={`find-form-switch-button ${ageGroup === 'senior' ? 'is-active' : ''}`} 
                  onClick={() => this.setState({ageGroup:'senior'})}>
                 Senior
                </div>
                <div 
                  className={`find-form-switch-button ${ageGroup === 'all' ? 'is-active' : ''}`} 
                  onClick={() => this.setState({ageGroup:'all'})}>
                  All
                </div>
              </div>
            </div>
            
            <div className="find-form-filter">
              <div className="find-form-select-title">Study Phase</div>
              <select
                className={`find-form-select ${studyPhase ? 'is-active' : ''}`}
                value={studyPhase}
                onChange={e => this.setState({studyPhase:e.target.value})}>
                <option value="">All</option>
                {Object.keys(phases).map(key => 
                  <option key={key} value={key}>{phases[key]}</option>
                )}
              </select>
            </div>
          </div>
          
          <div className="find-form-nav">
            <div>
              <button type="submit" className="find-form-submit">Search</button>
            </div>
            <div>
              <Link to="/subscription" className="find-form-alerts-button">New Trial Alerts</Link>
            </div>
          </div>

        </form>
        
        <div className="find-app">
          <div className="find-app-content">
            <p>Find Trials using your own device. Download our free app today!</p>
            <img src={qrcode} role="presentation" className="find-app-qr"/>
          </div>
          <img src={caduceus} role="presentation" className="find-app-caduceus"/>
        </div>
        
      </div>
    );
  }
  
  renderConditions() {
    return (
      <div>
        <h4 className="find-conditions-title">{lang('browse-conditions')}</h4>
        {conditions.map(this.renderCondition)}
      </div>
    );
  }
  
  renderMenu() {
    return (
      <div className="find-menu">
        <h5 className="find-menu-subtitle">Find Trials</h5>
        <Link to="/menu" className="find-menu-main">
          {lang('main-menu')} <Icon name="menuWhite" className="find-menu-main-icon"/>
        </Link>
      </div>
    );
  }
  
  renderMobileMenu() {
    return (
      <div className="find-menu-mobile">
        <div className="find-menu-back" onClick={() => hashHistory.push('/')}>
          <Icon name="prev" className="find-menu-back-icon"/>
        </div>
        <h5 className="find-menu-subtitle">Find Trials</h5>
      </div>
    );
  }
  
  render() {
    return (
      <div className="find">
        <div className="find-content-row">
          <div className="find-content-row-inner">
            <div className="find-content">{this.renderContent()}</div>
            <div className="find-conditions">{this.renderConditions()}</div>
          </div>
        </div>
        <div className="find-menu-row">
          {this.renderMenu()}
          {this.renderMobileMenu()}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Find.js